// Single entry point for the free /tools/ widgets. Each setup function is a
// no-op when its widget isn't on the page, so this is safe to call on every
// marketing page load.
import { setupQrGenerators } from "./generators"
import { setupQrDecoders } from "./decoder"
import { setupQrSizeCalculator } from "./size-calculator"

export function setupTools() {
  setupQrGenerators()
  setupQrDecoders()
  setupQrSizeCalculator()
}
